<template>
  <div>
    <l-map :center='mapCenter[index]' :zoom='zoom' style='height: 400px; width: auto;' ref="myMap">
      <l-tile-layer :url='url' :attribution='attribution'/>
      <l-circle v-for="(circle, index) in circles" :key="'circle'+index"
        :lat-lng="circle.coordinates"
        :radius="circle.radius"
        :color="circle.color"
        :visible="circle.visible"
      >
        <l-tooltip>{{ circle.coordinates}} - {{ getMiles(circle.radius) }} Mile Radius</l-tooltip>
      </l-circle>
      <div class="test" v-for="(geo, index) in geojson" :key="geo[0]">
        <l-geo-json :geojson="geo" :options="options" :optionsStyle="setColor(isNegative[index])">
        </l-geo-json>
      </div>
    </l-map>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LCircle, LGeoJson, LTooltip} from 'vue2-leaflet'

export default {
  name: 'LeafletMap',
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LGeoJson,
    LTooltip
  },
  props: ['index', 'campaignTarget', 'mapCenter'],

  data () {
    return {
      zoom: 9,
      url: 'https://api.mapbox.com/styles/v1/sokaldev/ck5zrj37522bu1ioy7r9a2osn/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic29rYWxkZXYiLCJhIjoiY2s1enI1eGdsMDA4dTNscGljdXExOWk0cCJ9.dEim2EATAKkLPW_6AO_YGQ',
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      geojson: [],
      circles: [],
      isNegative: [],
      radiusVisible: false,
      options: {
        onEachFeature: function onEachFeature(feature, layer) {
            layer.bindTooltip('Zip: ' + feature.properties.zipCode)
        }
      }
    }
  },
  mounted () {
    this.getData();
    this.$nextTick(() => {
      this.$refs.myMap.mapObject.invalidateSize()
    })
  },
  computed: {
    targetData () {
      return this.campaignTarget[this.index]
    }
  },

  methods: {
    getData () {
      const tData = this.targetData;

      for(const geo of tData){
        if(geo.geo_json) {
          this.geojson.push(geo.geo_json)
          this.isNegative.push(geo.is_negative)
        }
        if(geo.radius){
          this.circles.push(
            {
              radius: geo.radius * 1609,
              coordinates: [geo.latitude, geo.longitude],
              visible: geo.radius ? true : false,
              color: 'blue'
            }
          )
        }
      }
    },
    setColor (a) {
      return a ? { color: 'red' } : { color: 'blue'}
    },
    getMiles(i) {
     return Math.round(i*0.000621371192)
    }
  }
}
</script>
